export default __webpack_public_path__ + "23d8e71cf97aaedba689a85d096c6afe.svg";